module.exports = __webpack_public_path__ + "img/cart-shopping-fast.2b3d0722.svg";